import type { FunctionComponent } from 'react'
import React from 'react'

import { TraverseButton } from '../TraverseButton'

export const ScrollControls: FunctionComponent<Props> = ({
  buttonLabel,
  buttonClassNames,
  clickHandler,
  scrollPosition,
}) => {
  return (
    <>
      {!scrollPosition.atStart && (
        <TraverseButton
          disabled={scrollPosition.atStart}
          direction={'previous'}
          className={buttonClassNames?.left}
          labelSuffix={buttonLabel}
          onClick={() => clickHandler('previous')}
        />
      )}

      {!scrollPosition.atEnd && (
        <TraverseButton
          disabled={scrollPosition.atEnd}
          direction={'next'}
          className={buttonClassNames?.right}
          labelSuffix={buttonLabel}
          onClick={() => clickHandler('next')}
        />
      )}
    </>
  )
}

///////// IMPLEMENTATION /////////

export type Props = {
  /*
   *Button label
   */
  buttonLabel?: string
  /*
   *Button class names
   */
  buttonClassNames?: { left: string; right: string }
  /*
   *OnClick function for buttons
   */
  clickHandler: (arg: 'previous' | 'next') => void
  /*
   *Scroll position
   */
  scrollPosition: {
    atStart: boolean
    atEnd: boolean
    inMiddle?: boolean
  }
}
